import { mapGetters, mapState } from 'vuex';
import moment from 'moment';

import formatterMixin from '@shared/mixins/formatterMixin';
import formatCycleRuntime from '@shared/lib/formatter/formatCycleRuntime';
import formatPhoneNumber from '@shared/lib/formatter/formatPhoneNumber';

const customerDetailMixin = {
  mixins: [formatterMixin],
  computed: {
    ...mapState({
      states: (state) => state.general.states,
      showActionModal: (state) => state.customerDetail.showActionModal,
      activityTableSearch: (state) => state.customerDetail.activityTableSearch,
      actionModalView: (state) => state.customerDetail.actionModalView,
      uploadingImage: (state) => state.customerDetail.uploadingImage,
      cancellingSubscription: (state) => state.customerDetail.cancellingSubscription,
      requestingNameplate: (state) => state.customerDetail.requestingNameplate,
      gettingNameplateLogs: (state) => state.customerDetail.gettingNameplateLogs,
      latestNameplateLog: (state) => state.customerDetail.latestNameplateLog,
      cdTableOptions: (state) => state.customerDetail.cdTableOptions,
      loading: (state) => state.customerDetail.loading,
      cycleLoading: (state) => state.customerDetail.cycleLoading,
      deltaTFilter: (state) => state.customerDetail.cycleFilter.deltaT,
      activeTab: (state) => state.customerDetail.activeTab,
      customer: (state) => state.customerDetail.customer,
      subscription: (state) => state.customerDetail.subscription,
      providerPlan: (state) => state.customerDetail.providerPlan,
      propertyProfiles: (state) => state.customerDetail.propertyProfiles,
      propertyProfile: (state) => state.customerDetail.propertyProfile,
      alertTableData: (state) => state.customerDetail.alertTableData,
      activityTableData: (state) => state.customerDetail.activityTableData,
      dailyStats: (state) => state.customerDetail.dailyStats,
      cycleTableData: (state) => state.customerDetail.cycleTableData,
      deltaTTableData: (state) => state.customerDetail.deltaTTableData,
      cycleViewTab: (state) => state.customerDetail.cycleViewTab,
      infoEditing: (state) => state.customerDetail.infoEditing,
      billingEditing: (state) => state.customerDetail.billingEditing,
      shippingEditing: (state) => state.customerDetail.shippingEditing,
      showInfoEdit: (state) => state.customerDetail.showInfoEdit,
      showBillingEdit: (state) => state.customerDetail.showBillingEdit,
      showShippingEdit: (state) => state.customerDetail.showShippingEdit,
      newCustomerInfo: (state) => state.customerDetail.newCustomerInfo,
      newHVACInfo: (state) => state.customerDetail.newHVACInfo,
      newServiceAddress: (state) => state.customerDetail.newServiceAddress,
      newBillingAddress: (state) => state.customerDetail.newBillingAddress,
      newShippingAddress: (state) => state.customerDetail.newShippingAddress,
      selectedData: (state) => state.customerDetail.selectedData,
      cycleFilter: (state) => state.customerDetail.cycleFilter,
      selectedZoneSerial: (state) => state.customerDetail.cycleFilter.serial,
      hubs: (state) => state.customerDetail.hubs,
      tZones: (state) => state.customerDetail.tZones,
      hvac: (state) => state.customerDetail.hvac,
      systemNames: (state) => state.customerDetail.systemNames,
      filteredHvac: (state) => state.customerDetail.filteredHvac,
      sensors: (state) => state.customerDetail.sensors,
      filters: (state) => state.customerDetail.filters,
      runtimeGraphData: (state) => state.customerDetail.runtimeGraphData,
      loadingRuntimeGraph: (state) => state.customerDetail.loadingRuntimeGraph,
      alertsTabTableData: (state) => state.customerDetail.alertsTabTableData,
      alertTabCategories: (state) => state.customerDetail.alertTabCategories,
      alertShowType: (state) => state.customerDetail.alertShowType,
      loadingAlertsTab: (state) => state.customerDetail.loadingAlertsTab,
      activityLoading: (state) => state.customerDetail.activityLoading,
      generatingCSV: (state) => state.customerDetail.generatingCSV,
      exportCSV: (state) => state.customerDetail.exportCSV,
      selectedExportUid: (state) => state.customerDetail.exportCSV.uid,
      selectedSystemName: (state) => state.customerDetail.selectedSystemName,
      errorObj: (state) => state.customerDetail.errorObj,
      chronicAlerts: (state) => state.customerDetail.chronicAlerts,
      timescaleDays: (state) => state.customerDetail.timescaleDays,
      supplySensors: (state) => state.customerDetail.supplySensors,
      mergeCustomers: (state) => state.customerDetail.mergeCustomers,
      selectedMergeCustomer: (state) => state.customerDetail.selectedMergeCustomer,
      mergeForm: (state) => state.customerDetail.mergeForm,
      sendingEmail: (state) => state.customerDetail.sendingEmail,
      loadingMergeCustomers: (state) => state.customerDetail.loadingMergeCustomers,
      mergingMember: (state) => state.customerDetail.mergingMember,
      selectedHvac: (state) => state.customerDetail.currentHvac,
      currentHub: (state) => state.customerDetail.currentHub,
      selectedFilter: (state) => state.customerDetail.currentFilter,
      selectedSensor: (state) => state.customerDetail.currentSensor,
      commonFilters: (state) => state.customerDetail.commonFilters,
      selectedQuestionnaire: (state) => state.customerDetail.customer.questionnaire,
      selectedSerial: (state) => state.customerDetail.selectedSerial,
      pressureConversion: (state) => state.customerDetail.pressureConversion,
      activeTZoneFilter: (state) => state.customerDetail.systemFilter.singleTZone,
      allCorpPlans: (state) => state.customerDetail.allCorpPlans,
      filterBrands: (state) => state.customerDetail.filterBrands,
      virtualVisits: (state) => state.customerDetail.virtualVisits,
      selectedVirtualVisit: (state) => state.customerDetail.selectedVirtualVisit,
      selectedTechnician: (state) => state.customerDetail.selectedTechnician,
      technicianAvatar: (state) => state.customerDetail.technicianAvatar,
      customerOrders: (state) => state.customerDetail.customerOrders,
      loadingOrders: (state) => state.customerDetail.loadingOrders,
      coTableSearch: (state) => state.customerDetail.coTableSearch,
      coTableOptions: (state) => state.customerDetail.coTableOptions,
      recordingInProgress: (state) => state.customerDetail.recordingInProgress,
      filterOptions: (state) => state.customerDetail.filterOptions,
      ventOptions: (state) => state.customerDetail.ventOptions,
      thicknessList: (state) => state.customerDetail.thicknessList,
      smartThermostatList: (state) => state.customerDetail.smartThermostatList,
      memberAddress: (state) => state.customerDetail.memberAddress,
      systemFilter: (state) => state.customerDetail.systemFilter,
      customerPartnerSettings: (state) => state.customerDetail.customerPartnerSettings,
      performanceScores: (state) => state.customerDetail.performanceScores,
      loadingPerformanceScores: (state) => state.customerDetail.loadingPerformanceScores,
    }),
    ...mapGetters(['isSmacAdmin', 'adminRole', 'cdTableRecordCount', 'coTableRecordCount']),
    isA2SensorTempExist() {
      const sensorFound = this.sensors.find(
        (s) => s.serialNumber === this.activeTZoneFilter && s.sensorType === 'A2TempHumidity',
      );
      return sensorFound;
    },
    isA2RoomSensorExist() {
      const sensorFound = this.sensors.find((s) => {
        const { uid, sensorType } = s;
        const [selectedUid] = this.activeTZoneFilter.split('-');
        return uid === selectedUid && sensorType === 'A2RoomTempHumidity';
      });
      return sensorFound;
    },
  },
  methods: {
    getFilterLife(f) {
      const { currentLifePercent } = f;

      if (currentLifePercent === -1) {
        return 'Calculating';
      }

      const percent = currentLifePercent;

      if (percent !== null) {
        return `${percent}%`;
      }
      return '--';
    },
    formattedDate(d) {
      if (d) {
        return moment(d).format('M/DD/YYYY');
      }
      return '';
    },
    deviceStatus(s) {
      if (s && s.sensorRatio) {
        if (s.sensorRatio >= 0.9) {
          return 'Online';
        }
        if (s.sensorRatio >= 0.5) {
          return 'Fair';
        }
        if (s.sensorRatio >= 0) {
          return 'Weak';
        }
      }
      return 'Offline';
    },
    batteryStatus(s) {
      if (s && s.battery) {
        return s.battery[0].toUpperCase() + s.battery.slice(1);
      }
      return 'Off';
    },
    lastBatteryStatus(s) {
      if (s && s.lastBatteryState) {
        return s.lastBatteryState[0].toUpperCase() + s.lastBatteryState.slice(1);
      }
      return 'n/a';
    },
    sensorType(s) {
      if (s === 'Supply Air') {
        return 'Comfort';
      }
      if (s === 'Room Ambient') {
        return 'Filter';
      }
      if (s === 'Attic') {
        return 'Water';
      }
      return s;
    },
    getAlertSeverity(c) {
      if (c.alerts.length === 0) {
        return 'Healthy';
      }

      let alert = 'Watching';
      c.alerts.forEach((a) => {
        if (a.status === 'Urgent') {
          alert = 'Urgent';
        }
      });

      return alert;
    },
    timeInHours(t) {
      return moment(t).format('h:mmA');
    },
    runtime(r) {
      return formatCycleRuntime(r);
    },
    sbsFilterSize(f) {
      const { width: w, height: h, thickness: t, sbsHeight: sh, sbsWidth: sw } = f;

      const combinedWidth = w === sw ? w : (Number(w) + Number(sw)).toFixed(0);
      const combinedHeight = h === sh ? h : (Number(h) + Number(sh)).toFixed(0);
      let combinedSize = `${combinedWidth}x${combinedHeight}x${t}`;
      if (w === sw && h === sh) {
        combinedSize = `${w}x${(Number(h) + Number(sh)).toFixed(0)}x${t}`;
      }

      return `${combinedSize} (combined)`;
    },
    filterLife(f) {
      const { currentLifePercent } = f;

      if (currentLifePercent === -1) {
        return 'Calculating';
      }

      const percent = currentLifePercent;

      if (percent !== null) {
        return `${percent}%`;
      }
      return '--';
    },
    getHomeAge(s) {
      if (!s) {
        return '--';
      }
      return `${s.toString().slice(0, 3)}0s`;
    },
    toggleOrderActionModal(show, view) {
      if (!show) {
        this.$store.dispatch('changeOrderValues', [
          {
            field: 'showActionModal',
            value: false,
          },
          {
            field: 'newOrder',
            value: {},
          },
          {
            field: 'requestorId',
            value: '',
          },
        ]);
      } else {
        const changes = [
          {
            field: 'showActionModal',
            value: show,
          },
          {
            field: 'actionModalView',
            value: view,
          },
        ];
        this.$store.dispatch('changeOrderValues', changes);
      }
    },
    // TODO: Refactor required for toggleActionModal
    toggleActionModal(show, view, item, extraItem) {
      if (!show) {
        this.$store.dispatch('changeCustomerDetailValues', [
          {
            field: 'showActionModal',
            value: false,
          },
          {
            field: 'selectedMergeCustomer',
            value: {},
          },
          {
            field: 'selectedSerial',
            value: '',
          },
          {
            field: 'selectedExportUid',
            value: '',
          },
          {
            field: 'selectedFilter',
            value: {},
          },
          {
            field: 'currentFilter',
            value: {},
          },
          {
            field: 'showWrongDateRangePopup',
            value: false,
          },
        ]);
        this.$store.dispatch('resetExportCSVRange');
      } else {
        let field;
        let extraField;
        if (view === 'request-nameplate') {
          field = 'currentHvac';
        } else if (
          view === 'edit-filter' ||
          view === 'replace-filter' ||
          view === 'delete-filter'
        ) {
          field = 'currentFilter';
        } else if (
          view === 'upload-image' ||
          view === 'breakdown-risk' ||
          view === 'performance-score' ||
          view === 'performance-score-info'
        ) {
          field = 'currentHvac';
        } else if (view === 'edit-hub') {
          field = 'currentHub';
          extraField = 'currentHvac';
        } else if (view === 'hub-address-update') {
          field = 'currentHub';
        } else if (view === 'edit-sensor-details') {
          field = 'currentSensor';
        } else if (view === 'replace-sensor') {
          field = 'currentSensor';
        } else if (view === 'unverified-reasons') {
          field = 'currentHub';
        } else if (view === 'edit-visit') {
          field = 'selectedTechnician';
          extraField = 'technicianAvatar';
        }
        const changes = [
          {
            field,
            value: item,
          },
          {
            field: extraField,
            value: extraItem,
          },
          {
            field: 'showActionModal',
            value: show,
          },
          {
            field: 'actionModalView',
            value: view,
          },
        ];
        this.$store.dispatch('changeCustomerDetailValues', changes);
      }
    },
    toggleHVACProfileActionModal(show, view, item) {
      if (!show) {
        this.$store.dispatch('changeHvacProfileValue', {
          field: 'showActionModal',
          value: false,
        });
      } else {
        const selectedProfile = {
          ...item,
        };
        if (item.warranty) {
          selectedProfile.warranty = moment(item.warranty).format('MM/YYYY');
        }
        const changes = [
          {
            field: 'showActionModal',
            value: show,
          },
          {
            field: 'actionModalView',
            value: view,
          },
          {
            field: 'selectedProfile',
            value: selectedProfile,
          },
        ];
        this.$store.dispatch('changeHvacProfileValues', changes);
      }
    },
    uploadImage() {
      this.$store.dispatch('uploadHvacImage');
    },
    getRuntimeGraph(type, value) {
      this.$store.dispatch('setRuntimeGraph', {
        field: type,
        value,
      });
    },
    changeTab(tab) {
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'activeTab',
        value: tab,
      });
      if (tab === 'deltaT') {
        localStorage.setItem('timezonePref', 'local');
        this.$store.dispatch('changeDeviceDetailValue', {
          key: 'timezone',
          value: 'local',
        });
      }
      if (tab === 'cycle' || tab === 'deltaT' || tab === 'runtime') {
        this.$store.dispatch('getCustomerCycles');
      }
    },
    setAlertDot(c) {
      if (c.alerts.length === 0) {
        return 'green';
      }

      let color = 'yellow';
      c.alerts.forEach((a) => {
        if (a.type === 'Error') {
          color = 'red';
        }
      });

      return color;
    },
    changePage(pageNum) {
      const sIndex = (pageNum - 1) * 50;
      this.data = this.tableData.slice(sIndex, sIndex + 50);
      this.page = pageNum;

      if (this.columnHeaders) {
        const columnLength = this.data.reduce((acc, d) => {
          let highestNum = acc;
          if (d.deltaTs) {
            if (d.deltaTs.length > highestNum) {
              highestNum = d.deltaTs.length;
            }
          }
          return highestNum;
        }, 0);

        const columnHeaders = ['Start'];
        for (let i = 0; i < columnLength; i += 1) {
          columnHeaders.push(`${5 * (i + 1)} Min`);
        }
        this.columnHeaders = columnHeaders;
      }
    },
    filterAlertsTab(filter, value) {
      this.$store.dispatch('setFilterAlertsTab', {
        filter,
        value,
      });
    },
    filterActivityTab(filter, value) {
      this.$store.dispatch('setFilterActivityTab', {
        filter,
        value,
      });
    },
    toggleAlertType(type) {
      this.$store.dispatch('toggleAlertTypeType', {
        value: type,
      });
    },
    determineACMode(c) {
      const { acMode, supplyAir, returnAir } = c;

      if (supplyAir && returnAir && supplyAir.minTemp !== 32 && returnAir.minTemp !== 32) {
        if (acMode === 'Cool') {
          return 'blue';
        }
        if (acMode === 'Heat') {
          return 'red';
        }
      }

      return '';
    },
    async sendWelcomeEmail(email, isPortal) {
      await this.$store.dispatch('sendWelcomeEmail', {
        email,
        isPortal,
      });
      this.toggleActionModal(false);
    },
    setCustomerDetailEdit(field) {
      this.$store.dispatch('setCustomerDetailEdit', {
        field,
      });
    },
    updateContactInfo() {
      this.$store.dispatch('updateContactInfo');
    },
    changeCustomerDetailInfo(field, value) {
      let v = value;
      if (field === 'phone') {
        v = formatPhoneNumber(value);
      }
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'newCustomerInfo',
        value: { ...this.newCustomerInfo, [field]: v },
      });
    },
    determineFilterStatus(f) {
      const life = f.currentLifePercent;

      if (life === -1 || life === 0) {
        return 'red-text';
      }

      const percent = life;

      if (percent > 80) {
        return 'green-text';
      }
      if (percent > 50) {
        return 'yellow-text';
      }
      if (!percent) {
        return 'no-life';
      }
      return 'red-text';
    },
    removeChronicAlert(uid, alertType) {
      this.$store.dispatch('removeChronicAlert', {
        uid,
        alertType,
      });
    },
    setIsValidDot(isValid) {
      if (isValid) {
        return '';
      }
      return 'red dot';
    },
    determineDeviceStatus(s) {
      if (s && s.sensorRatio) {
        if (s.sensorRatio >= 0.9) {
          return 'green-text';
        }
        if (s.sensorRatio >= 0.5) {
          return 'yellow-text';
        }
        if (s.sensorRatio >= 0) {
          return 'red-text';
        }
      }
      return 'red-text';
    },
    determineBatteryStatus(s) {
      if (s && s.battery) {
        const b = s.battery.toLowerCase();
        if (b === 'good') {
          return 'green-text';
        }
        if (b === 'warning') {
          return 'yellow-text';
        }
        if (b === 'low') {
          return 'red-text';
        }
      }
      return 'red-text';
    },
  },
};

export default customerDetailMixin;
